/**
 * HR 狀態 → StatusDot 色調對照（docs/介面優化.md R6，全 HR 只在這裡定義一次）
 * success 完成／在職、warning 待處理、danger 異常、neutral 草稿／離職、accent 進行中
 */
import type { StatusTone } from '@redpanda/ui';

export const employeeTone: Record<string, StatusTone> = {
  ACTIVE: 'success',
  ON_LEAVE: 'warning',
  RESIGNED: 'neutral',
};

export const attendanceTone: Record<string, StatusTone> = {
  PRESENT: 'success',
  LEAVE: 'accent',
  HOLIDAY: 'neutral',
  ABSENT: 'danger',
};

/** 請假：待審核＝黃（需要處理）、核准＝綠、拒絕＝灰 */
export const leaveTone: Record<string, StatusTone> = {
  PENDING: 'warning',
  APPROVED: 'success',
  REJECTED: 'neutral',
};

/** 薪資：草稿＝灰、已確認＝主題色（待發放）、已發放＝綠 */
export const payrollTone: Record<string, StatusTone> = {
  DRAFT: 'neutral',
  CONFIRMED: 'accent',
  PAID: 'success',
};

export const toneOf = (map: Record<string, StatusTone>, value?: string | null): StatusTone =>
  (value && map[value]) || 'neutral';
